<form [formGroup]="formGroup">


  <mat-form-field appearance="outline">
    <mat-label>Layer name</mat-label>
    <input matInput formControlName="displayName"/>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Description</mat-label>
    <textarea matInput formControlName="description"
              cdkTextareaAutosize
              cdkAutosizeMinRows="5"
              cdkAutosizeMaxRows="5">
    </textarea>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Layer Group</mat-label>
    <mat-select formControlName="layerGroup">
      @for (group of groups(); track group.id) {
        <mat-option [value]="group.id">{{ group.displayName }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Service type</mat-label>
    <mat-select formControlName="serviceType">
      @for (serviceType of serviceTypes.values(); track serviceType.toString()) {
        <mat-option [value]="serviceType">{{ serviceType.toString() }}</mat-option>
      }
    </mat-select>
  </mat-form-field>


  <mat-form-field appearance="outline">
    <mat-label>Service layer</mat-label>
    <input matInput formControlName="serviceLayer"/>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Service URL</mat-label>
    <input matInput formControlName="serviceUrl"/>
  </mat-form-field>


  <h3>Attribution Data</h3>

  <mat-form-field appearance="outline">
    <mat-label>Attribution Title</mat-label>
    <input matInput formControlName="attributionTitle"/>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Attribution URL</mat-label>
    <input matInput formControlName="attributionUrl"/>
  </mat-form-field>


  <mat-slide-toggle formControlName="enabled">Shows in map</mat-slide-toggle>

</form>

<div class="action-buttons">
  <button mat-button color="primary" [disabled]="formGroup.invalid" (click)="updateLayer()"> Update</button>
  <button mat-button color="warn" (click)="cancelLayerUpdate()"> Cancel</button>
</div>
